import lightbox from 'lightbox2';
jQuery(document).ready(function($) {
	lightbox.option({
        'resizeDuration': 200,
        'wrapAround': true
    })
});